import {Component, OnInit, OnDestroy, Input, AfterViewInit, EventEmitter, Output} from '@angular/core';
import {WebcamImage, WebcamInitError, WebcamUtil} from 'ngx-webcam';
import { Subject, Subscription } from 'rxjs';
import {Observable} from 'rxjs/Observable';
import {ActivatedRoute, Router} from '@angular/router';
import {KycService} from 'src/app/core/services/kyc.service';
import {ToastrService} from 'ngx-toastr';
import {MatDialog} from '@angular/material';
// import {ConfirmFailComponent} from '../confirm-fail/confirm-fail.component';
// import {ConfirmSuccessComponent} from '../confirm-success/confirm-success.component';
import {ErrorCode} from "src/app/core/constants/error-code";
import { Message } from 'src/app/core/class/message';
import { DialogFailComponent } from '../dialog-fail/dialog-fail.component';
import { DialogSuccessComponent } from '../dialog-success/dialog-success.component';
import { ResponsiveService } from 'src/app/core/services/responsive.service';
import { SCREEN_SIZE } from 'src/app/core/constants/screen-size';


@Component({
  selector: 'app-ekyc-camera',
  templateUrl: './ekyc-camera.component.html',
  styleUrls: ['./ekyc-camera.component.scss']
})
export class EkycCameraComponent implements OnInit, OnDestroy, AfterViewInit {
  // toggle webcam on/off
  public showWebcam = true;
  public allowCameraSwitch = true;
  public multipleWebcamsAvailable = false;
  public deviceId: string;
  public videoOptions: MediaTrackConstraints = {
  };
  @Input() isPassport: boolean;
  @Input() isSignDigitalCertificate: boolean;

  public errors: WebcamInitError[] = [];

  // webcam snapshot trigger
  private trigger: Subject<void> = new Subject<void>();
  // switch to next / previous / specific webcam; true/false: forward/backwards, string: deviceId
  private nextWebcam: Subject<boolean|string> = new Subject<boolean|string>();

  faceImage: WebcamImage = null;
  cccdBeforeImage: WebcamImage = null;
  cccdAfterImage: WebcamImage = null;
  passportImage: WebcamImage = null;
  modalImage: WebcamImage = null;
  typeCamera = {
    face: 'face',
    before: 'before',
    after: 'after',
    passport: 'passport'
  };
  typeCameraChoose;
  dataCCCD = {
    typeImage: 8,
    images: [
      {
        type: 80,
        base64Image: '',
        fileName: 'cccd_before.png',
        description: 'File ảnh CMND/CCCD mặt trước',
      },
      {
        type: 81,
        base64Image: '',
        fileName: 'cccd_after.png',
        description: 'File ảnh CMND/CCCD mặt sau',
      },
      {
        type: 85,
        base64Image: '',
        fileName: 'face_image.png',
        description: 'File ảnh khuôn mặt'
      }
    ]
  };

  dataPassport = {
    typeImage: 9,
    images: [
      {
        type: 90,
        base64Image: '',
        fileName: 'passport_image.png',
        description: 'File ảnh hộ chiếu',
      },
      {
        type: 85,
        base64Image: '',
        fileName: 'face_image.png',
        description: 'File ảnh khuôn mặt'
      }
    ]
  };
  checkCapture = false;
  checkCaptureAgain = false;
  checkFaceImage = false;
  checkCccdBeforeImage = false;
  checkCccdAfterImage = false;
  checkPassportImage = false;
  private tenantId: string;
  private hashKey: string;

  subscription: Subscription;
  screenSize: string;
  @Output() eventCloseDialog = new EventEmitter();
  @Output() eventSign = new EventEmitter();

  constructor(private router: Router,
              private kycService: KycService,
              private toastr: ToastrService,
              public dialog: MatDialog,
              public message: Message,
              private route: ActivatedRoute,
              public responsiveService: ResponsiveService
            ) {
  }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.hashKey = params.get('hashKey');
      this.tenantId = params.get('tenantId');
    });

    this.typeCameraChoose = this.typeCamera.face;
    this.checkCaptureAgain = true;
    WebcamUtil.getAvailableVideoInputs()
      .then((mediaDevices: MediaDeviceInfo[]) => {
        this.multipleWebcamsAvailable = mediaDevices && mediaDevices.length > 1;
      });
    this.subscription = this.responsiveService._getMediaBreakpoint().subscribe(media => {
      this.screenSize = media;
    });
  }

  ngAfterViewInit() {
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  handleCamera(type) {
    if (type) {
      this.typeCameraChoose = type;
      this.checkCapture = false;
      this.checkCaptureAgain = true;
      if (this.screenSize === SCREEN_SIZE.SM || this.screenSize === SCREEN_SIZE.XS || this.screenSize === SCREEN_SIZE.MD) {
        const camera = document.getElementById('camera-view');
        camera.scrollIntoView({
          behavior:'smooth',
          block: 'center',
          inline:'center'
        });
      }
    }
  }

  zoomImage(type) {
    if (type) {
      if (type === this.typeCamera.face) {
        this.modalImage = this.faceImage;
      }
      if (type === this.typeCamera.before) {
        this.modalImage = this.cccdBeforeImage;
      }
      if (type === this.typeCamera.after) {
        this.modalImage = this.cccdAfterImage;
      }
      if (type === this.typeCamera.passport) {
        this.modalImage = this.passportImage;
      }
    }
  }

  closeZoomImage() {
    this.modalImage = null;
  }

  handleImage(webcamImage: WebcamImage): void {
    if (this.typeCameraChoose === this.typeCamera.face) {
      this.faceImage = webcamImage;
    }
    if (this.typeCameraChoose === this.typeCamera.before) {
      this.cccdBeforeImage = webcamImage;
    }
    if (this.typeCameraChoose === this.typeCamera.after) {
      this.cccdAfterImage = webcamImage;
    }
    if (this.typeCameraChoose === this.typeCamera.passport) {
      this.passportImage = webcamImage;
    }
  }

  captureAgain() {
    this.checkCapture = false;
    this.checkCaptureAgain = true;
    if (this.typeCameraChoose === this.typeCamera.face) {
      this.faceImage = null;
    }
    if (this.typeCameraChoose === this.typeCamera.before) {
      this.cccdBeforeImage = null;
    }
    if (this.typeCameraChoose === this.typeCamera.after) {
      this.cccdAfterImage = null;
    }
    if (this.typeCameraChoose === this.typeCamera.passport) {
      this.passportImage = null;
    }
  }

  getDataImage() {
    let data;
    if (!this.isPassport) {
      // CMND/CCCD
      if (this.faceImage) {
        this.checkFaceImage = false;
        const arr = this.faceImage.imageAsDataUrl.split(",");
        this.dataCCCD.images[2].base64Image = arr[1];
      } else {
        this.checkFaceImage = true;
      }
      if (this.cccdBeforeImage) {
        this.checkCccdBeforeImage = false;
        const arr = this.cccdBeforeImage.imageAsDataUrl.split(",");
        this.dataCCCD.images[0].base64Image = arr[1];
      } else {
        this.checkCccdBeforeImage = true;
      }
      if (this.cccdAfterImage) {
        this.checkCccdAfterImage = false;
        const arr = this.cccdAfterImage.imageAsDataUrl.split(",");
        this.dataCCCD.images[1].base64Image = arr[1];
      } else {
        this.checkCccdAfterImage = true;
      }

      if (!this.checkFaceImage && !this.checkCccdAfterImage && !this.checkCccdBeforeImage) {
        data = this.dataCCCD;
        return data;
      }

    } else {
      // Passport
      if (this.faceImage) {
        this.checkFaceImage = false;
        const arr = this.faceImage.imageAsDataUrl.split(",");
        this.dataPassport.images[1].base64Image = arr[1];
      } else {
        this.checkFaceImage = true;
      }
      if (this.passportImage) {
        this.checkPassportImage = false;
        const arr = this.passportImage.imageAsDataUrl.split(",");
        this.dataPassport.images[0].base64Image = arr[1];
      } else {
        this.checkPassportImage = true;
      }

      if (!this.checkFaceImage && !this.checkPassportImage) {
        data = this.dataPassport;
        return data;
      }
    }
  }

  handleReaderLoaded(readerEvt) {
    if (!this.isPassport) {
      if (this.faceImage) {
        const binaryString = readerEvt.target.result;
        this.dataCCCD.images[2].base64Image = btoa(binaryString);
      }
    } else {
      if (this.faceImage) {
        const binaryString = readerEvt.target.result;
        this.dataPassport.images[1].base64Image = btoa(binaryString);
      }
    }

    if (this.cccdBeforeImage) {
      const binaryString = readerEvt.target.result;
      this.dataCCCD.images[0].base64Image = btoa(binaryString);
    }
    if (this.cccdAfterImage) {
      const binaryString = readerEvt.target.result;
      this.dataCCCD.images[1].base64Image = btoa(binaryString);
    }
    if (this.passportImage) {
      const binaryString = readerEvt.target.result;
      this.dataPassport.images[0].base64Image = btoa(binaryString);
    }
  }

  public triggerSnapshot(): void {
    if (this.errors && this.errors[0] && this.errors[0].message) {
      // TODO show popup
    }
    this.checkCapture = true;
    this.checkCaptureAgain = false;
    this.trigger.next();
  }

  public handleInitError(error: WebcamInitError): void {
    this.errors.push(error);
  }

  public cameraWasSwitched(deviceId: string): void {
    console.log('active device: ' + deviceId);
    this.deviceId = deviceId;
  }

  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }

  public get nextWebcamObservable(): Observable<boolean|string> {
    return this.nextWebcam.asObservable();
  }

  onCloseDialog() {
    this.eventCloseDialog.emit()
  }

  sign() {
    this.eventSign.emit();
  }

}

